module.exports = __webpack_public_path__ + "static/media/gran-cru-dark.d423a514.jpg";